import { Checkbox, FormControlLabel, Grid, MenuItem, Paper, TextField } from '@mui/material'
import type { SupplierFilters as SupplierFiltersType } from './SupplierList.types'
import { ManufacturerSearchAutocomplete } from 'src/helper'
import './SupplierFilters.css'

export interface SupplierFiltersProps {
  filters: SupplierFiltersType
  onFiltersChange: (filters: SupplierFiltersType) => void
  typeOptions: string[]
}

export function SupplierFilters({ filters, onFiltersChange, typeOptions }: SupplierFiltersProps) {
  const updateFilter = (key: keyof SupplierFiltersType, value: string | boolean) => {
    onFiltersChange({ ...filters, [key]: value })
  }

  return (
    <Paper elevation={0} className="supplier-filters-paper">
      <Grid container spacing="24px" alignItems="center">
        <Grid size={3.5}>
          <TextField
            value={filters.supplier}
            onChange={e => updateFilter('supplier', e.target.value)}
            label="Suppliers"
            size="small"
            fullWidth
          />
        </Grid>

        <Grid size={3.5}>
          <ManufacturerSearchAutocomplete
            value={filters.oem}
            onChange={value => updateFilter('oem', value ?? '')}
            label="OEM"
            fullWidth
          />
        </Grid>

        <Grid size={3.5}>
          <TextField
            fullWidth
            size="small"
            select
            value={filters.type}
            onChange={e => updateFilter('type', e.target.value)}
            label="Type"
          >
            <MenuItem value="">
              <em>Type</em>
            </MenuItem>
            {typeOptions.map(t => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid size="auto">
          <FormControlLabel
            label="Blanket"
            control={<Checkbox checked={filters.blanket} onChange={e => updateFilter('blanket', e.target.checked)} />}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}
